<template>
  <div ref="optOut" class="opt-out-report-section">
    <h5 class="data-title text-center">opt out report</h5>
    <div v-if="error" class="error-label text-center">{{error}}</div>
    <div class="opt-outs-content">
      <div class="opt-outs-header bottom">
        <opt-out-count countType="visit"
                       extraClasses="opt-outs-header-section"
                       :memberCount="optout && optout.withVisits"
                       @reloadReport="reloadReport"></opt-out-count>

        <div class="total-opt-outs opt-outs-header-section">
          <div class="total-opt-outs">{{optout ? optout.totalOptouts : 0}}</div>
          total opt outs
        </div>

        <opt-out-count countType="point"
                       extraClasses="opt-outs-header-section"
                       :memberCount="optout && optout.withPoints"
                       @reloadReport="reloadReport"></opt-out-count>
      </div>

      <bar-graph v-if="graphData && wrapperWidth && !error"
                 :barSelectorData="['amount']"
                 :graphData="graphData"
                 :toolTipContent="toolTipContent"
                 :wrapperHeight="wrapperHeight"
                 :wrapperWidth="wrapperWidth"
                 xPadding="0"
                 xSelector="date_time"
                 hideXticks
                 topRounded
                 @setToolTipContent="setToolTipContent"></bar-graph>
    </div>
  </div>
</template>

<script>
  import BarGraph from '../Graphs/BarGraph'
  import InputItem from '../FormItems/InputItem'
  import NumberInput from '../FormItems/NumberInput'
  import LinkToggle from '../shared/LinkToggle'
  import OptOutCount from './OptOutCount'
  import ReportsMixin from '../../mixins/ReportsMixin'
  import ToolTipContentMixin from '../../mixins/ToolTipContentMixin'

  export default {
    props: {
      error: String,
      graphData: Array,
      optout: Object,
      wrapperWidth: [Number, String],
    },

    name: 'OptOutReport',

    components: {
      BarGraph,
      InputItem,
      LinkToggle,
      NumberInput,
      OptOutCount,
    },

    mixins: [ReportsMixin, ToolTipContentMixin],

    data() {
      return {
        point: 1,
        reportType: 'optout',
        toolTipContent: null,
        visit: 1,
      }
    },

    methods: {
      loadData() {
        const params = {
          params: {
            min_visits: this.visit,
            min_points: this.point
          }
        }
        this.$emit('loadGraphData', this.reportType, this.reportType, params)
      },

      reloadReport(countType, countTotal) {
        (countType && countTotal) && (this[countType] = countTotal)
        this.loadData()
      },

      setToolTipContent(item) {
        this.toolTipContent = this.getToolTipContent(item, this.reportType)
      }
    },

    created() {
      this.loadData()
    },


    computed: {
      wrapperHeight: function () {
        return this.wrapperWidth ? this.wrapperWidth * 0.5 : 0
      }
    },
  }
</script>